import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { NavLink } from "../types/nav";

const DEFAULT_LINKS: NavLink[] = [
  { label: "Home", to: "/#section-1" },
  { label: "Como funciona", to: "/#section-2" },
  { label: "Perguntas frequentes", to: "/#section-6" },
  { label: "Quanto custa", to: "/#section-7" },
];

const MenuContainer = styled.nav`
  position: relative;

  @media (max-width: 991px) {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
  }
`;

const MenuIcon = styled.div`
  display: none;
  cursor: pointer;

  @media (max-width: 991px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    background-color: #e4da1b;
    border-radius: 50%;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
    transition: transform 0.15s ease;

    &:active {
      transform: scale(0.92);
    }
  }
`;

const BalloonMenu = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 60px;
  right: 0;
  width: 200px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.25);
  padding: 15px;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transform: ${({ isOpen }) =>
    isOpen ? "translateY(0) scale(1)" : "translateY(-12px) scale(0.95)"};
  pointer-events: ${({ isOpen }) => (isOpen ? "auto" : "none")};
  transition: opacity 0.25s ease, transform 0.25s ease;
`;

const MenuItem = styled(Link)`
  display: block;
  padding: 10px;
  color: #000;
  text-decoration: none;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  border-radius: 6px;
  opacity: 0;
  animation: fadeIn 0.25s ease forwards;

  &:hover {
    background-color: #f1f1f1;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-6px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

interface MenuMobileProps {
  links?: NavLink[];
}

const MenuMobile: React.FC<MenuMobileProps> = ({ links = DEFAULT_LINKS }) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = () => setIsOpen(false);

  return (
    <MenuContainer>
      <MenuIcon onClick={() => setIsOpen((prev) => !prev)}>
        {!isOpen ? (
          <Icon icon="mdi:menu" width={28} height={28} color="#000" />
        ) : (
          <Icon icon="mdi:close" width={28} height={28} color="#000" />
        )}
      </MenuIcon>
      <BalloonMenu isOpen={isOpen}>
        {links.map((link) => (
          <MenuItem key={link.to} onClick={closeMenu} to={link.to}>
            {link.label}
          </MenuItem>
        ))}
      </BalloonMenu>
    </MenuContainer>
  );
};

export default MenuMobile;
